"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _construct = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/reflect/construct"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

require("../../../util/GlobalScript.js");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _underscore = _interopRequireDefault(require("underscore"));

var _HelpHint = _interopRequireDefault(require("../../tooltips/HelpHint"));

var _ExpandableRow = require("./ExpandableRow");

var _Chip = _interopRequireWildcard(require("../../layout/Chip"));

var _class, _temp, _class2, _temp2, _class3, _temp3;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @class Status
 * @memberof ExpandableRow
 * @desc An expandable row status component.
 *
 * @param {string} [data-id="status"]
 *    To define the base "data-id" value for the top-level HTML container.
 *
 * @param {ExpandableRow.Statuses} [status]
 *    The status of the expandable row status component.
 *
 * @example
 *      <Status data-id="row-status-good" status={ExpandableRow.Statuses.GOOD} />
 */
exports.Status = (_temp = _class = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(_class, _React$Component);

  var _super = _createSuper(_class);

  function _class() {
    (0, _classCallCheck2.default)(this, _class);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(_class, [{
    key: "render",
    value: function render() {
      var className = (0, _classnames.default)("status", this.props.status);
      return /*#__PURE__*/_react.default.createElement("div", {
        "data-id": this.props["data-id"],
        className: className
      });
    }
  }]);
  return _class;
}(_react.default.Component), (0, _defineProperty2.default)(_class, "propTypes", {
  "data-id": _propTypes.default.string,
  status: _propTypes.default.oneOf([_ExpandableRow.Statuses.GOOD, _ExpandableRow.Statuses.ERROR, _ExpandableRow.Statuses.WARNING])
}), (0, _defineProperty2.default)(_class, "defaultProps", {
  "data-id": "status"
}), _temp);
/**
* @callback PillButton~onClick
*
* @param {object} e
*     The ReactJS synthetic event object.
*/

/**
 * @class PillButton
 * @memberof ExpandableRow
 * @desc An expandable row pill button component.
 *
 * @param {string} [data-id="pill-button"]
 *    To define the base "data-id" value for the top-level HTML container.
 *
 * @param {string} [label]
 *    The label for the pill button.
 * @param {PillButton~onClick} [onClick]
 *    Callback to be triggerred the button is clicked.
 *
 * @example
 *      <PillButton data-id="basic-pill-button" label="Pill Button" onClick={this.props.onClick} />
 */

exports.PillButton = (_temp2 = _class2 = /*#__PURE__*/function (_React$Component2) {
  (0, _inherits2.default)(_class2, _React$Component2);

  var _super2 = _createSuper(_class2);

  function _class2() {
    (0, _classCallCheck2.default)(this, _class2);
    return _super2.apply(this, arguments);
  }

  (0, _createClass2.default)(_class2, [{
    key: "render",
    value: function render() {
      var props = _underscore.default.defaults({
        "data-id": this.props["data-id"],
        children: this.props.label,
        className: "inline"
      }, this.props);

      return /*#__PURE__*/_react.default.createElement("button", props);
    }
  }]);
  return _class2;
}(_react.default.Component), (0, _defineProperty2.default)(_class2, "propTypes", {
  "data-id": _propTypes.default.string,
  label: _propTypes.default.string,
  onClick: _propTypes.default.func
}), (0, _defineProperty2.default)(_class2, "defaultProps", {
  "data-id": "pill-button"
}), _temp2);
/**
 * @class HelpLabel
 * @memberof ExpandableRow
 * @desc An expandable row help label component.
 *
 * @param {string} [data-id="help-label"]
 *    To define the base "data-id" value for the top-level HTML container.
 *
 * @param {string} label
 *    The label for the help tooltip.
 * @param {string} hintText
 *    The help hint text for the help label.
 *
 * @example
 *      <HelpLabel data-id="basic-help-label" label="Help Label" hintText="Help Hint Text" />
 */

exports.HelpLabel = (_temp3 = _class3 = /*#__PURE__*/function (_React$Component3) {
  (0, _inherits2.default)(_class3, _React$Component3);

  var _super3 = _createSuper(_class3);

  function _class3() {
    (0, _classCallCheck2.default)(this, _class3);
    return _super3.apply(this, arguments);
  }

  (0, _createClass2.default)(_class3, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement(_HelpHint.default, {
        className: this.props.className,
        hintText: this.props.hintText
      }, /*#__PURE__*/_react.default.createElement(_Chip.default, {
        type: _Chip.chipTypes.CONDENSED
      }, this.props.label));
    }
  }]);
  return _class3;
}(_react.default.Component), (0, _defineProperty2.default)(_class3, "propTypes", {
  "data-id": _propTypes.default.string,
  label: _propTypes.default.string.isRequired,
  className: _propTypes.default.string,
  hintText: _propTypes.default.string.isRequired
}), (0, _defineProperty2.default)(_class3, "defaultProps", {
  "data-id": "help-label",
  className: "width-auto bottom"
}), _temp3);